export default __webpack_public_path__ + "livi.a436bad7.png";